 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		78: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"4":"component---src-pages-accessibility-overview-mdx","5":"component---src-pages-components-atoms-avatars-mdx","6":"component---src-pages-components-atoms-badge-mdx","7":"component---src-pages-components-atoms-buttons-mdx","8":"component---src-pages-components-atoms-form-check-mdx","9":"component---src-pages-components-atoms-form-input-mdx","10":"component---src-pages-components-atoms-icon-mdx","11":"component---src-pages-components-atoms-loader-mdx","12":"component---src-pages-components-atoms-logo-mdx","13":"component---src-pages-components-atoms-separator-mdx","14":"component---src-pages-components-atoms-skeleton-mdx","15":"component---src-pages-components-atoms-tag-mdx","16":"component---src-pages-components-atoms-toggle-mdx","17":"component---src-pages-components-molecules-accordion-mdx","18":"component---src-pages-components-molecules-breadcrumb-mdx","19":"component---src-pages-components-molecules-bubble-chat-mdx","20":"component---src-pages-components-molecules-button-group-mdx","21":"component---src-pages-components-molecules-calendar-mdx","22":"component---src-pages-components-molecules-carousel-mdx","23":"component---src-pages-components-molecules-composer-mdx","24":"component---src-pages-components-molecules-counter-mdx","25":"component---src-pages-components-molecules-dropdown-mdx","26":"component---src-pages-components-molecules-empty-state-mdx","27":"component---src-pages-components-molecules-file-attachment-mdx","28":"component---src-pages-components-molecules-from-group-mdx","29":"component---src-pages-components-molecules-media-mdx","30":"component---src-pages-components-molecules-message-mdx","31":"component---src-pages-components-molecules-modal-mdx","32":"component---src-pages-components-molecules-multi-steps-mdx","33":"component---src-pages-components-molecules-overlay-mdx","34":"component---src-pages-components-molecules-pagination-mdx","35":"component---src-pages-components-molecules-problem-info-mdx","36":"component---src-pages-components-molecules-progress-mdx","37":"component---src-pages-components-molecules-rating-mdx","38":"component---src-pages-components-molecules-search-box-mdx","39":"component---src-pages-components-molecules-session-type-mdx","40":"component---src-pages-components-molecules-sidebar-menu-mdx","41":"component---src-pages-components-molecules-slider-mdx","42":"component---src-pages-components-molecules-tab-mdx","43":"component---src-pages-components-molecules-tag-input-mdx","44":"component---src-pages-components-molecules-toast-mdx","45":"component---src-pages-components-molecules-top-banner-mdx","46":"component---src-pages-components-molecules-top-menu-mdx","47":"component---src-pages-components-organisms-ask-box-mdx","48":"component---src-pages-components-organisms-card-mdx","49":"component---src-pages-components-organisms-chat-box-mdx","50":"component---src-pages-components-organisms-header-mdx","51":"component---src-pages-css-utilities-animation-mdx","52":"component---src-pages-css-utilities-borders-mdx","53":"component---src-pages-css-utilities-box-shadow-mdx","54":"component---src-pages-css-utilities-colors-mdx","55":"component---src-pages-css-utilities-cursors-mdx","56":"component---src-pages-css-utilities-display-mdx","57":"component---src-pages-css-utilities-filters-mdx","58":"component---src-pages-css-utilities-object-fit-mdx","59":"component---src-pages-css-utilities-opacities-mdx","60":"component---src-pages-css-utilities-position-mdx","61":"component---src-pages-css-utilities-spacing-mdx","62":"component---src-pages-css-utilities-svg-mdx","63":"component---src-pages-css-utilities-text-mdx","64":"component---src-pages-css-utilities-user-select-mdx","65":"component---src-pages-foundations-colors-mdx","66":"component---src-pages-foundations-illustration-mdx","67":"component---src-pages-getting-started-introduction-mdx","68":"component---src-pages-getting-started-support-mdx","69":"component---src-pages-index-js","70":"component---src-pages-layout-block-layout-mdx","71":"component---src-pages-layout-flex-box-mdx","72":"component---src-pages-layout-grid-mdx","73":"component---src-pages-layout-list-mdx","74":"component---src-pages-layout-page-layout-mdx","75":"component---src-pages-layout-split-pane-mdx","76":"component---src-pages-layout-table-mdx","77":"component---src-pages-release-notes-mdx"}[chunkId]||chunkId) + "-" + {"2":"6dc32a114e1233782a1e","4":"352211a55e563a32cf1e","5":"9fa3d5a4d665fdd1f610","6":"ae3efdac6ec17beba29f","7":"f1badbfb6a95454c3f4a","8":"bb1b9dbd024dda270527","9":"9a479f050602edf12133","10":"fb2423232b1afcb19a28","11":"1a1345e2feb10a908c16","12":"82733a3edc6bb2479d8a","13":"62b8edf0b026299f5baa","14":"7c733cb2033f81fe1bc0","15":"824e255310194aaa89c3","16":"4afc8ec7074ba5ca5861","17":"5fafa996abd5bb504b29","18":"ec3ee1babd56411d879e","19":"5738cfca8902c18a59c6","20":"9feb4be56d2fc957da9c","21":"0ca96208a18cacb23f97","22":"c4bfae93b7971546006c","23":"daa2c4e045288bc408f9","24":"c46e9478f69d8c5dc168","25":"7f27a79b9bb59a242201","26":"e8710452cc8b30ce26e5","27":"3bb8f0a0b7563d75f40a","28":"243653993b088b63b2e1","29":"cdcbd75ec3d6979e9889","30":"b7c35f2d1ce2ebaf20ed","31":"3d2760f4a3306538dd7a","32":"46490931a99127cab7e8","33":"1de4fd202d3fd220855f","34":"02235c9ba4c39b2f81c2","35":"9856a10c483c3c72400a","36":"9c9b195ef09dd71775f4","37":"9bb42c8f70c3203b93f3","38":"801a3ea0e617fe7ce84f","39":"40942bbf16376bfb6962","40":"a5b8f66ea0cbe4de9d82","41":"e830fd1e90fcacb4f90d","42":"41d3d3f24a4c9c21d76f","43":"5bdfd1cded708c13fa18","44":"4a12b4daad4d4dde0eae","45":"0417ec49f87b94018327","46":"afd1159042eacbc2004f","47":"a0e9bfbec38fff6089b5","48":"857d87a1d95f0a2bb00a","49":"d6d70db2041d1d791048","50":"333b9bd7441f7d5e7936","51":"2eed0276051c8291d54c","52":"4ad67b9f020dba652001","53":"3c5232e1bfa0bf05ea17","54":"a82489ed603f2650dbbb","55":"7982ed6ea82d98844be6","56":"cd1eed38d66df9e423e6","57":"0a2147f22bee33f201c0","58":"8bb0bc8a527c858eedce","59":"d2fa6a4bb512a4accff1","60":"13aa9bd15f4901626897","61":"e8afb9c695b72afcf0ef","62":"f8b5bab698c11cd20650","63":"3d1d5bd96033621f14f5","64":"dfe79f0277294ebb44e2","65":"6565ecd5b186ef49351d","66":"a641754d5fb0afeb2297","67":"bef397d7c27c43d819f8","68":"f9f2df2d10e51426fea7","69":"ffefdd147d2234051850","70":"7a2c618dc362a5c5598f","71":"762672f34ecc4a7e9238","72":"f3c12a95ed271c15e356","73":"cf733ce736797d2b44a7","74":"1f23cec5d54c936d3fd4","75":"c9def95da039eb4c404e","76":"f3e8ff7346b7cfd179c1","77":"aa00c72537dc386c7a3a"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
